import { render, staticRenderFns } from "./BuyerEditCampaign.vue?vue&type=template&id=48205081&scoped=true"
import script from "./BuyerEditCampaign.vue?vue&type=script&lang=js"
export * from "./BuyerEditCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48205081",
  null
  
)

export default component.exports